<template>
  <div id="forgetlogin">
    <video id="v2" autoplay loop muted height="800rem" width="800rem">
      <source
        src="../assets/mp4/ebs.mp4"
        type="video/mp4"
      />
    </video>
    <div class="login-d">
      <div class="video-login">
        <div id="v1"></div>
        <div id="login-item">
          <div id="login-web">
            <h1 id="login-logo"><img src="../assets/img/logo.png" alt="" /></h1>
            <div id="login-text">
              <span class="text">数</span>
              <span></span>
              <span>字</span>
              <span></span>
              <span>孪</span>
              <span></span>
              <span>生</span>
              <span></span>
              <span>能</span>
              <span></span>
              <span>源</span>
              <span></span>
              <span>互</span>
              <span></span>
              <span>联</span>
              <span></span>
              <span>网</span>
              <span></span>
              <span>平</span>
              <span></span>
              <span>台</span>
            </div>
          </div>
          <div id="kong"></div>
          <div id="login-user">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              class="demo-ruleForm"
              :label-width="auto"
              :label-position="left"
            >
              <el-form-item label="新密码" prop="password">
                <el-input
                  id="inp"
                  type="password"
                  v-model="ruleForm.password"
                  autocomplete="off"
                ></el-input>
                <div
                  class="progress"
                  v-if="
                    ruleForm.password.length >= 6 &&
                      ruleForm.password.length <= 18
                  "
                >
                  <div class="trangle"></div>
                  <p class="int">{{ text }}</p>
                  <el-progress
                    :percentage="percentage"
                    :color="customColorMethod"
                  ></el-progress>
                  <p class="font">
                    请使用数字、小写字母、大写字母、特殊符号至少两种或两种6位以上不容易被猜到的密码。
                  </p>
                </div>
              </el-form-item>
              <div class="kong1"></div>
              <el-form-item label="确认密码" prop="checkPass">
                <el-input
                  id="inp2"
                  type="password"
                  v-model="ruleForm.checkPass"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <div class="kong1"></div>
              <el-form-item prop="email" label="输入邮箱">
                <el-input
                  id="inp3"
                  type="type"
                  v-model="ruleForm.email"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <div class="kong1"></div>
              <el-form-item id="cede" label="验证码" prop="age">
                <el-input id="inp4" v-model="ruleForm.age"></el-input>
                <el-button
                  class="btn1"
                  type="info"
                  :disabled="btnget"
                  :plain="btnas"
                  @click="userEmail"
                  size="10rem"
                  >{{ get }}{{ textget }}</el-button
                >
              </el-form-item>
              <div class="kong2"></div>
              <el-form-item class="item-btn">
                <div class="item-btn">
                  <el-button
                    class="btn2"
                    type="primary"
                    @click="submitForm('ruleForm')"
                    >提交</el-button
                  >
                  <router-link class="btn-a" to="login">返回登录</router-link>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="login-mvker">
        <div class="mvker-item">
          <p class="mvker-text">武汉魅客科技有限公司</p>
          <h4 class="mvker-logo">
            <img src="../assets/img/text.png" alt="" />
          </h4>
        </div>
        <div class="copyright">版权 © 2021武汉魅客科技出品</div>
      </div>
    </div>
  </div>
</template>

<script>
import { play } from "../api/login";
// import { passwordMd5 } from '../util/md5.js'
export default {
  name: "forgetlogin",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === "" || value.trim() === "") {
        callback(new Error("请输入密码"));
        document.querySelector("#inp").style.borderBottom = "1px solid red";
      } else {
        var ls = 0;
        var oProgress = document.getElementsByClassName("progress");
        if (this.ruleForm.password == "") {
          document.querySelector("#inp").style.borderBottom = "1px solid red";
     
        } else {
          if (ls > 1) {
            document.querySelector("#inp").style.borderBottom = "1px solid red";
            oProgress.style = "display:block";
          }
          if (this.ruleForm.password.match(/([a-z])+/)) {
            ls++;
          }
          if (this.ruleForm.password.match(/([0-9])+/)) {
            ls++;
          }
          if (this.ruleForm.password.match(/([A-Z])+/)) {
            ls++;
          }
          if (
            this.ruleForm.password.match(/([\W])+/) &&
            !this.ruleForm.password.match(/(![\u4E00-\u9FA5])+/)
          ) {
            ls++;
          }
          if (
            this.ruleForm.password.length < 6 ||
            this.ruleForm.password.length > 18
          ) {
            document.querySelector("#inp").style.borderBottom = "1px solid red";
            callback(new Error("要求6-18位字符"));
            ls = 0;
          } else {
            document.querySelector("#inp").style.borderBottom =
              "1px solid gainsboro";
          }

          if (this.ruleForm.password.match(/([\u4E00-\u9FA5])+/)) {
            callback(new Error("不能包含中文字符"));
            ls = 0;
          }

          switch (ls) {
            case 0:
              this.percentage = 0;
              callback;
              break;
            case 1:
              this.percentage = 33;
              document.querySelector("#inp").style.borderBottom =
                "1px solid red";
              callback(
                new Error("密码必须大小写、数字、特殊符号两种或两种以上！")
              );

              break;
            case 2:
              this.percentage = 66;
              callback;
              break;
            case 3:
              this.percentage = 100;
              break;
            // case 4:
            // default:
            //   this.percentage = 0;
            //   break;
          }
        }
        callback();
      }
    };

    var validatePass2 = (rule, value, callback) => {
      if (value === "" || value.trim() === "") {
        document.querySelector("#inp2").style.borderBottom = "1px solid red";
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        document.querySelector("#inp2").style.borderBottom = "1px solid red";
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
        document.querySelector("#inp2").style.borderBottom =
          "1px solid gainsboro";
      }
    };
    var email = (rule, value, callback) => {
      var t = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
   
      if (value === "" || value.trim() === "") {
        callback(new Error("请输入邮箱"));
        document.querySelector("#inp3").style.borderBottom = "1px solid red";
      } else if (t.test(value) !== true) {
        callback(new Error("邮箱格式不正确"));
        document.querySelector("#inp3").style.borderBottom = "1px solid red";
      } else {
        callback();
        document.querySelector("#inp3").style.borderBottom =
          "1px solid gainsboro";
      }
    };
    var checkAge = (rule, value, callback) => {
      if (value === "") {
        document.querySelector("#inp4").style.borderBottom = "1px solid red";
        callback(new Error("请输入验证码"));
      } else {
        document.querySelector("#inp4").style.borderBottom =
          "1px solid gainsboro";
        callback();
      }
    };
    return {
      errMsg: "",
      textget: "",
      btnas: false,
      btnget: false,
      get: "获取验证码",
      isShow: true,
      customColor: "#409eff", //颜色
      percentage: 0, //进度条
      customColors: [{ color: "#f56c6c", percentage: 31 }],
      text: "",
      ruleForm: {
        password: "",
        checkPass: "",
        age: "",
        email: "",
      },
      rules: {
        password: [
          {
            validator: validatePassword,
            trigger: ["blur", "change"],
          },
        ],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        age: [{ validator: checkAge, trigger: "blur" }],
        email: [{ validator: email, trigger: "blur" }],
      },
    };
  },
  methods: {
    customColorMethod(percentage) {
      if (percentage < 34) {
        this.text = "强度：弱";
        // document.querySelector(".int").style.color = "#FD4238";
        return "#FD4238";
      } else if (percentage < 67) {
        this.text = "强度：中";
        // document.querySelector(".int").style.color = "#e6a23c";
        return "#e6a23c";
      } else {
        this.text = "强度：强";
        // document.querySelector(".int").style.color = "#68D86A";

        return "#68D86A";
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //修改密码
          // let pass=passwordMd5(this.ruleForm.password)
          let pass = this.ruleForm.password;

          play
            .changePassword(this.ruleForm.age, this.ruleForm.email, pass)
            .then((res) => {
              if (res.data.status) {
                // console.log(res.data);
                this.$router.push("/result");
                window.localStorage.setItem("Useremail", this.ruleForm.email);
              } else {
                // console.log(res.data);
                this.$message({
                  customClass: "maessage",
                  showClose: true,
                  message: "验证码错误",
                  type: "error",
                  showClose: true,
                });
              }
            });
        } else {
        
          return false;
        }
      });
    },
    //获取验证码
    userEmail() {
      var t = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (t.test(this.ruleForm.email)) {
        let lsemail = window.localStorage.getItem("email");
        if (lsemail == this.ruleForm.email) {
          this.textget = "秒后重发";
          this.get = window.localStorage.getItem("time");
          this.btnget = true;
          this.btnas = true;
          this.timer();
        } else {
          play.sendEmail(this.ruleForm.email).then((res) => {
            window.localStorage.setItem("email", this.ruleForm.email);
            this.textget = "秒后重发";
            this.get = 60;
            this.btnget = true;
            this.btnas = true;
            this.timer();
          });
        }
      } else {
        this.$message.error("请输入邮箱或格式正确的邮箱号");
      }
    },
    timer() {
      let timer = setInterval(() => {
        this.get--;
        window.localStorage.setItem("time", this.get);

        if (this.get < 1) {
          clearInterval(timer);
          this.get = "获取验证码";
          this.btnget = false;
          this.btnas = false;
          this.textget = "";
          window.localStorage.removeItem("time");
          window.localStorage.removeItem("email");
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="less">
#forgetlogin {
  width: 100%;
  height: 100%;
}

 
           .login-mvker {
            line-height: 40px;
            margin-top: 2%;

            .mvker-item {
                width: 300px;
                margin: auto;
                display: flex;
                justify-content: space-around;

                .mvker-text {
                    white-space: nowrap;
                    font-size: 16px;
                    text-align: center;
                    color: #999999;
                    // margin-bottom: 3%;
                }

                .mvker-logo {
                   width: 75px;
                   height: 15px;
                    text-align: right;

                    img {
                      width: 75px;
                   height: 15px;
                    }
                }
            }

            .copyright {
                // .w(230);
                margin: auto;
                font-size: 16px;
                text-align: center;
                color: #999999;
            }
        }
#login-web {
  .w(290);
  margin: auto;
  margin-top: 22%;

  #login-logo {
    img {
      width: 100%;
      height: 100%;
    }
  }
  #login-text {
    .w(286);
    display: flex;
    justify-content: space-between;
    color: #0d94ff;
    span {
      font-size: 18px;
    }
  }
}
#kong {
  .h(81);
}
#login-user {
  position: relative;
  .w(600);
  height: 52.8vh;
  box-shadow: 0px 0px 40px 0px rgba(0, 43, 102, 0.16);
  border-radius: 12px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50rem 10rem 10rem 10rem;
  // margin-bottom:10rem;
  background-color: #ffffff;
  .user-p {
    .h(25);
    font-size: 24rem;
  }
}

.btn-a {
  height: 80rem;
  // margin-top: 0%;
  // line-height: 20rem;
  text-align: center;
  line-height: 90rem;
  margin-left: 130rem;
  color: #0d94ff;
  text-decoration: none;
}

.progress {
  // .w(300) !important;
  // .h(170);
  box-shadow: 0px 0px 20px 0px rgba(0, 43, 102, 0.16);
  padding: 24rem 23rem 10rem 23rem;
  border-radius: 5rem;
  background: #ffffff;
  position: absolute;
  top: -30rem;
  left: 330rem;
  width: 300rem;
  display: block;
  .font {
    padding: 5rem;
    font-size: 14rem;
    color: #666666;
    line-height: 30rem;
  }
  .int {
    font-size: 18rem;
    color: #666666;
  }
}
.trangle {
  width: 0;
  height: 0;
  position: absolute;
  border: 13rem solid rgba(255, 255, 255, 0);
  // box-shadow: 0px 0px 40px 0px rgba(0, 43, 102, 0.16);
  border-right-color: #ffffff;
  margin-left: -50rem;
  margin-top: 20rem;
  z-index: 200;
}
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
video:focus {
  outline: none;
}
#v1 {
  // padding: 50rem;
  margin-top: 8%;
  .w(800);
  .h(800);
  z-index: 0;
}
#v2 {
  // padding: 50rem;
  margin-top: 6%;
  position: absolute;
  .w(800);
  .h(800);
  z-index: 0;
  left: 10%;
}
.video-login {
  display: flex;
  justify-content: space-between;
  z-index: 1;
  // padding-left: 200rem;
}
.kong1 {
  .h(28);
}
.kong2 {
  .h(40);
}
.login-d {
  width: 100%;
  height: 100%;
  background: url(../assets/img/loginBJ1.png);
  //  background-color: #ffffff;
  background-size: 100% 100%;
  position: fixed;
  z-index: 9;
  padding: 0 14% 0 10%;
}
.item-btn {
  font-size: 16rem !important;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
